import { Grid, Typography } from "@mui/material";
import { useStyles } from "../Common/CommonStyle";
import excellarateLogo from "../../images/Excellarate logo 8.svg";
import chrome from "../../images/chrome.svg";
import firefox from "../../images/firefox.svg";
import edge from "../../images/edge.svg";
import safari from "../../images/safari.svg";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export const IncompatibleBrowser = () => {
  const classes = useStyles();

  return (
    <Grid container className={classes.positionComponent} sx={{ background: '#fff', height: '100vh', padding: '40px 24px' }}>
      <Grid item xs={12}>
        <img src={excellarateLogo} alt="logo" />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h3" sx={{ display: 'flex', justifyContent: 'center', fontWeight: 600, fontSize: '72px', lineHeight: '85px', marginTop: '2rem', color: '#1E1F4A' }}>Incompatible browser!</Typography>
        <Typography sx={{ width: '70%', margin: '0 auto', fontWeight: 400, fontSize: '24px', marginTop: '1rem', color: '#1E1F4A' }}>
          Looks like your browser does not support WebGL, that is required to explore the metaverse. You might need to upgrade your browser or try opening in a different browser.
          To learn more about using WebGL on your device, {" "}
          <a href="https://get.webgl.org/get-a-webgl-implementation/" target="_blank" style={{ fontWeight: 600, color: '#1E1F4A' }} rel="noreferrer">click here</a>.
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography sx={{ fontWeight: 600, fontSize: '24px', marginTop: '1.5rem', color: '#1E1F4A', display: 'flex', alignItems: 'center' }}><span>View compatible browsers </span><ArrowForwardIosIcon sx={{ marginLeft: '30px' }} /></Typography>
        <Typography sx={{ fontWeight: 400, fontSize: '16px', marginTop: '12px', color: '#848484' }}>or you may try opening in:</Typography>
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', gap: '64px' }}>
        <img src={safari} alt="tablet" style={{ height: '45px', width: 'auto' }} />
        <img src={chrome} alt="desktop" style={{ height: '45px', width: 'auto' }} />
        <img src={firefox} alt="laptop" style={{ height: '45px', width: 'auto' }} />
        <img src={edge} alt="tablet" style={{ height: '45px', width: 'auto' }} />
      </Grid>
      <Grid item xs={12}>
        <Typography sx={{ fontWeight: 400, fontSize: '14px', marginTop: '1rem', color: '#888888;' }}>© 2022 Excellarate. All Rights Reserved</Typography>
      </Grid>
    </Grid>
  );
};
